/**
 * Match lambdas/addTeamLogo format_team_filename:
 * "Sheffield Blazers A" -> "Sheffield-Blazers-A"
 */
export function formatTeamLogoFilename(teamName: string): string {
  const words = teamName.trim().match(/[A-Za-z0-9]+/g) ?? [];
  return words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join('-');
}

/**
 * Ordered logo filenames to try. A/B sides fall back to the parent club logo
 * when a side-specific file has not been uploaded.
 */
export function getTeamLogoFilenameCandidates(teamName: string): string[] {
  const primary = formatTeamLogoFilename(teamName);
  const candidates = [primary];
  const parts = primary.split('-');

  if (parts.length > 1 && /^[A-Za-z]$/.test(parts[parts.length - 1])) {
    candidates.push(parts.slice(0, -1).join('-'));
  }

  if (parts.length > 1 && /^\d+$/.test(parts[parts.length - 1])) {
    const withoutNumber = parts.slice(0, -1).join('-');
    if (!candidates.includes(withoutNumber)) {
      candidates.push(withoutNumber);
    }
  }

  return candidates;
}

export function getTeamLogoPath(teamName: string, filename: string): string {
  return `/images/teamLogos/${filename}.png`;
}

export function isTigersTeam(team: string): boolean {
  const normalized = team.trim().toLowerCase();
  return normalized === 'tigers' || normalized === 'sheffield ice tigers';
}
